var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcMlp24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#101233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64751 6.22749L7.20239 6.58365L9.24479 3.46173L9.64751 6.22749Z",
    fill: "#CAFFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8954 21.6653L10.6651 21.8443L5.29391 10.6685L5.53439 10.3008L10.1429 9.62976L11.8954 21.6653Z",
    fill: "#CAFFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3355 5.39907L12.8904 5.75523L12.48 2.93811L15.3355 5.39907Z",
    fill: "#CAFFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2938 8.88194L16.1583 21.0447L15.1383 21.1935L13.3858 9.15746L17.8565 8.5061L18.2938 8.88194Z",
    fill: "#CAFFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1934 7.72946L17.9054 5.75282L12.2813 6.5717L11.6386 2.1557L9.82032 2.42018L10.4635 6.83666L4.83936 7.65554L5.12736 9.63218L10.7515 8.8133L12.6082 21.5616L14.4259 21.2967L12.5693 8.54834L18.1934 7.72946Z",
    fill: "#03F5AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMlp24);
export default __webpack_public_path__ + "static/media/ic_mlp_24.4c50b443e57609dec9c12a78a3f6697d.svg";
export { ForwardRef as ReactComponent };